import { ref, onMounted, onUnmounted, isRef } from "vue";
import type { Ref } from "vue";

/**
 * @function useBreakpoint - composable to determine if the screen is below a threshold
 * @param {Ref<number> | number} breakpointValue - the threshold in pixels
 * @param {boolean} below - check if the screen si below, if false, checks if the screen si above
 * @returns {Ref<boolean>} flag for threshold passed
 */
export default function useBreakpoint(
  breakpointValue: Ref<number> | number,
  below = true
): Ref<boolean> {
  const breakpoint = ref(true);
  const breakpointNumber = isRef(breakpointValue)
    ? breakpointValue
    : ref(breakpointValue);
  function checkBreakpoint() {
    if (below) {
      breakpoint.value = window.innerWidth < breakpointNumber.value;
    } else {
      breakpoint.value = window.innerWidth > breakpointNumber.value;
    }
  }

  //attach isMobileSize to lifecycle hook
  onMounted(() => {
    window.addEventListener("load", checkBreakpoint);
    window.addEventListener("resize", checkBreakpoint);
  });
  //attach isMobileSize to lifecycle hook
  onUnmounted(() => {
    window.removeEventListener("load", checkBreakpoint);
    window.removeEventListener("resize", checkBreakpoint);
  });

  return breakpoint;
}
